import { TypeKeys } from '../actions/index.js';
import { updateActionStatePhase } from '../common/index.js';
import { ActionPhase } from '../common/storeUtils.js';
import { reduceCrudAction } from './reducerUtils.js';
import type { PunchoutOrderState } from '../../common/types/states.js';
import type { ActionTypes } from '../actions/index.js';
import type { ActionsHistory } from '../common/store.js';

export function punchoutOrderReducer(
  state: (PunchoutOrderState & ActionsHistory) | undefined,
  action: ActionTypes
): (PunchoutOrderState & ActionsHistory) | null {
  if (typeof state === 'undefined') {
    return null;
  }

  switch (action.type) {
    case TypeKeys.SUBMIT_PUNCHOUT_ORDER: {
      return {
        ...reduceCrudAction(action, state),
        saving: true,
      };
    }

    case TypeKeys.SUBMIT_PUNCHOUT_ORDER_FULFILLED: {
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.SUBMIT_PUNCHOUT_ORDER,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.SUCCESS
        ),
        errors: undefined,
        saving: false,
      };
    }

    case TypeKeys.SUBMIT_PUNCHOUT_ORDER_FAILED: {
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.SUBMIT_PUNCHOUT_ORDER,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.FAILED
        ),
        errors: action.errors,
        saving: false,
      };
    }

    default:
      return state;
  }
}
